<div class="flex tb-text-to-date justify-between">
  <input [formControl]="fc" autocomplete="off" (focus)="onFocusIn($event)" (blur)="onFocusOut($event)" class="flex-1" />
  <div>{{ displayValue$ | async }}</div>
</div>
